import Axios from 'axios';
import { Api as bindAxios, Codes } from 'api';
import { Message } from 'element-ui';
const bindApi = bindAxios.post.postStudentWecomBind;
const api = Axios.create();
const base_url = process.env.VUE_APP_SCRM_API_BASE;
const page_origin = window.location.origin;
// const page_origin = 'http://172.18.1.94:2030';
export const wecom_param_key = 'wecom_param';
export const eid_key = 'WECOM_EID';
import Error from './error';
const localKeys = {
  reload: 'WECOM_ENTRY_HREF'
};
const apis = {
  auth: '/api/v1/wecom/app/hsylc/oauth',
  eid: '/api/v1/wecom/app/hsylc/authorize'
};
const pages = {
  bind: '/register',
  entry: '/wecom/oauth/entry',
  middle: '/wecom/oauth/middle',
  success: '/wecom/oauth/success',
  fail: '/wecom/oauth/fail'
};
const getToken = async () => {
  return localStorage.getItem('STUDENT_TOKEN');
};
const toast = {
  success: msg => {
    Message.success(msg);
  },
  error: msg => {
    Message.error(msg);
  }
};
export const bindWecom = async (json, success_url = page_origin + pages.success, fail_url = page_origin + pages.fail) => {
  return new Promise((resolve, reject) => {
    bindApi(JSON.parse(json)).then(res => {
      if (res.status === Codes.SUCCESS) {
        window.location.href = success_url;
        localStorage.removeItem(localKeys.reload);
        resolve(res.data);
      } else {
        Error.setError(res.msg);
        window.location.href = fail_url;
        reject(res);
      }
    });
  });
};
export const postEid = async (app_bind_url = page_origin + pages.bind, success_url = page_origin + pages.success, fail_url = page_origin + pages.fail) => {
  const code = getRequest().code;
  const url = `${base_url}${apis.eid}`;
  const token = await getToken();
  const reloadUrl = localStorage.getItem(localKeys.reload);
  return new Promise((resolve, reject) => {
    api
      .post(url, { code, app_bind_url })
      .then(_res => {
        const res = _res.data;
        const code = res.code;
        const canReload = code === 66;
        if (canReload && reloadUrl) {
          window.location.href = reloadUrl;
        } else if (code) {
          toast.error(res.message);
          Error.setError(res.message);
          reject(res);
          window.location.href = fail_url;
        } else {
          let data = res.data;
          if (data?.user_bind_para && Object.keys(data.user_bind_para).length) {
            let json = JSON.stringify(data.user_bind_para);
            if (token) {
              bindWecom(json).then(res1 => resolve(res1));
            } else {
              let url = app_bind_url + '?' + wecom_param_key + '=' + encodeURIComponent(json);
              window.location.href = url;
              resolve(res.data);
            }
          } else {
            Error.cleanError();
            window.location.href = fail_url + '/user_bind_para';
            reject({
              code: -1,
              message: '绑定失败'
            });
          }
        }
      })
      .catch(ex => {
        toast.error(JSON.stringify(ex));
        window.location.href = fail_url + '/eid_request';
      });
  });
};
export const postOauth = async (return_url = page_origin + pages.middle, fail_url = page_origin + pages.fail) => {
  localStorage.setItem(localKeys.reload, window.location.href);
  const url = `${base_url}${apis.auth}`;
  return new Promise((resolve, reject) => {
    api
      .post(url, {
        scope: 'base',
        return_url
      })
      .then(_res => {
        const res = _res.data;
        const code = res.code;
        if (code) {
          toast.error(res.message);
          reject(res);
          Error.setError(res.message);
          window.location.href = fail_url;
        } else {
          resolve(res.data);
          window.location.href = res.data.url;
        }
      })
      .catch(ex => {
        toast.error(JSON.stringify(ex));
        window.location.href = fail_url + '/oauth_request';
      });
  });
};
export const getRequest = decode => {
  let ifDecode = true;
  if (decode === false) {
    ifDecode = false;
  }
  let url = location.search;
  let theRequest = {};
  if (url && url.length && url.indexOf('?') > -1) {
    let str = url.substr(1);
    let strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      if (ifDecode) {
        theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
      } else {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
  }
  return theRequest;
};
